import React, { useCallback } from 'react';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import ProjectSettingsGeneral from './ProjectSettings/ProjectSettingsGeneral';
import { useHistory } from 'react-router';
import { Project } from '@/types';
import { Breadcrumbs } from '@ygtechnologies/bygr-frontend-component-library';

interface CreateProjectProps {}

const CreateProject: React.FC<CreateProjectProps> = (props) => {
    const history = useHistory();

    const handleSave = useCallback(
        (project: Project) => {
            history.push(`/projects/${project.id}`);
        },
        [history]
    );

    return (
        <>
            <SimplePageTitle title={t`Create new project`} />

            <Breadcrumbs>
                <Breadcrumbs.Link to="/projects">
                    <Trans>Projects</Trans>
                </Breadcrumbs.Link>

                <Breadcrumbs.Item>
                    <Trans>Create new project</Trans>
                </Breadcrumbs.Item>
            </Breadcrumbs>

            <ProjectSettingsGeneral onSave={handleSave} />
        </>
    );
};

export default CreateProject;
